import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  results: {
    position: 'absolute',
    width: '560px',
    borderRadius: '4px',
    backgroundColor: palette.shades[100],
    padding: '8px 0',
    boxShadow: palette.shadows.light,
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '420px'
    }
  },
  result: {
    padding: '7px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    transition: "all ".concat(palette.transitions.short),
    '& path': {
      fill: palette.shades[600]
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: palette.shades[200]
    }
  },
  tenantIcon: {
    marginRight: '10px',
    alignSelf: 'flex-start'
  },
  address: {
    color: palette.shades[600],
    fontSize: '15px',
    lineHeight: '20px'
  },
  resultCategory: {
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300]),
      marginTop: '8px',
      paddingTop: '8px'
    }
  }
}));
export default useStyles;